import { createSlice, createAsyncThunk, createSelector } from '@reduxjs/toolkit';
import {HOSTNAME} from '../../Configs/Domain';
// Cloud Run service-api-url

// Async thunk for fetching portfolio time series data
export const getAllocationHistory = createAsyncThunk(
  'timeSeriesModels/getAllocationHistory',
  async ({ pid, startDate, endDate }, { getState, rejectWithValue }) => {
    try {
      // Construct the URL based on parameters
      let url = `${HOSTNAME}/performance/allocation/${pid}?`;
      if (!startDate){
        startDate = '2018-01-01';
      }
      url += `sd=${startDate}&`;
      if (endDate) {
        url += `ed=${endDate}&`;
      }
      url = url.slice(0, -1); // Remove the trailing '&'

      // Use fetch or any other HTTP client that you prefer
      const response = await fetch(url);
      if (!response.ok) throw new Error('Network response was not ok');
      const data = await response.json();
      return { pid, data };
    } catch (error) {
      return rejectWithValue(error.toString());
    }
  }
);


// Slice for managing time series data
const timeSeriesModelsSlice = createSlice({
  name: 'timeSeriesModels',
  initialState: {

    allocation: {}, // Store portfolio data by pid
    loading: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Portfolio time series
      .addCase(getAllocationHistory.pending, (state, action) => {
        state.loading = 'loading';
      })
      .addCase(getAllocationHistory.fulfilled, (state, action) => {
        const { pid, data } = action.payload;
        state.allocation[pid] = data;
        state.loading = 'succeeded';
      })
      .addCase(getAllocationHistory.rejected, (state, action) => {
        state.loading = 'failed';
        state.error = action.payload;
      })
  },
});

// Selectors
export const selectAllocationHistory = createSelector(
  [(state, pid) => state.timeSeriesModels.allocation[pid]],
  (timeSeries) => timeSeries
);

export default timeSeriesModelsSlice.reducer;
